import { SwitchLang } from "@/components/example/switch-lang";
import Logo from "@/components/shared/logo";
import CloseIcon from "@/components/ui/close-icon";
import { Dispatch, SetStateAction } from "react";

type TitleBarProps = {
  setIsOpen: Dispatch<SetStateAction<boolean>>;
};

export default function TitleBar({ setIsOpen }: TitleBarProps) {
  return (
    <div className="flex items-center justify-between">
      <Logo />
      <div className="flex items-center gap-3">
        <SwitchLang />
        <CloseIcon
          className="my-auto flex h-[44px] w-[44px] items-center justify-center rounded-full border-2 border-none border-[#F3D5A9]/30 bg-transparent text-sm leading-none sm:h-[60px] sm:w-[60px] sm:text-xl xl:hidden"
          onClick={() => setIsOpen(false)}
        />
      </div>
    </div>
  );
}
